import {
  Settings, Users, Activity, FileText, BarChart3, Bell, Shield, Handshake, Globe, Mail, Link2, ToggleLeft, LayoutDashboard, ListChecks,
} from 'lucide-react';
import type { NavItem } from '../types/navigation';

export type AdminNavItem = Pick<NavItem, 'key' | 'label' | 'path' | 'icon'> & {
  /** If true, this link performs a JWT handoff to the extranet */
  external?: boolean;
};

export const ADMIN_NAV: AdminNavItem[] = [
  // BMS Sprint 1 Stream D — surfaced first so admins land on the portfolio view
  { key: 'portfolio', label: 'BMS Portfolio', path: '/admin/portfolio', icon: LayoutDashboard },
  // BMS Sprint 2 Stream M — G3 Reinspection workflow queue
  { key: 'reinspection-queue', label: 'Reinspection Queue', path: '/admin/reinspection-queue', icon: ListChecks },
  { key: 'integrations', label: 'Integrations', path: '/admin/integrations', icon: Settings },
  { key: 'users', label: 'Users', path: '/admin/users', icon: Users },
  { key: 'roles', label: 'Roles', path: '/admin/roles', icon: Shield },
  { key: 'partners', label: 'Partners', path: '/admin/partners', icon: Handshake },
  { key: 'partner-domains', label: 'Partner Domains', path: '/admin/partner-domains', icon: Link2 },
  { key: 'pending-invites', label: 'Pending Invites', path: '/admin/pending-invites', icon: Mail },
  { key: 'flags', label: 'Flags', path: '/admin/flags', icon: ToggleLeft },
  { key: 'health', label: 'Health', path: '/admin/health', icon: Activity },
  { key: 'logs', label: 'Logs', path: '/admin/logs', icon: FileText },
  { key: 'kpis', label: 'KPIs', path: '/admin/kpis', icon: BarChart3 },
  { key: 'alerts', label: 'Alerts', path: '/admin/alerts', icon: Bell },
  { key: 'extranet', label: 'Extranet', path: '/v1/extranet/auth', icon: Globe, external: true },
];
